// TiptapEditor/MenuBar/ScriptGroup.js
import React from "react";

export default function ScriptGroup({ editor }) {
  if (!editor) return null;

  return (
    <div className="menubar-group">
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleSuperscript().run()}
        className={editor.isActive("superscript") ? "is-active" : ""}
        title="Superíndice (Ctrl/Cmd + .)"
      >
        x<sup>2</sup>
      </button>

      <button
        type="button"
        onClick={() => editor.chain().focus().toggleSubscript().run()}
        className={editor.isActive("subscript") ? "is-active" : ""}
        title="Subíndice (Ctrl/Cmd + ,)"
      >
        x<sub>2</sub>
      </button>
    </div>
  );
}
